<template>
    <div class="grid">
        <div class="card col-12 mainTitle">
            <h3 class="stationsHeader">{{ translated('allhomevisitsoverview').toUpperCase() }}</h3>                
        </div>
        <DataTable stateStorage="local" stateKey="dt-state-locations-session" :value="allanalysis" :paginator="true" class="p-datatable-allhomevisits" :rows="10"
        responsiveLayout="stack" breakpoint="200px"    
        dataKey="id" :rowHover="true" v-model:filters="filters1" filterDisplay="menu" :loading="isLoading"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50]"
            currentPageReportTemplate="Prikaz {first} do {last} od {totalRecords} patronaža"
            :globalFilterFields="['name','surname', 'clientNotes']">
            
            <template #header>
                <div class="p-d-flex p-jc-between searchPlaceholder">
                    <span class="p-input-icon-right">
                        <i class="pi pi-search" />
                        <InputText v-model="filters1['global'].value" :placeholder="this.translated('keywordsearch')" />
                    </span>
                </div>
            </template>
            <template #empty>
                {{ translated('norecordsfound') }}
            </template>
            <template #loading>
                {{ translated('loadingdata') }}
            </template>
            <Column :header="translated('namesurname')"  :sortable="false" headerStyle="text-align: left" bodyStyle="text-align: left">
                <template #body="slotProps">
                    {{ slotProps.data.name + ' ' +slotProps.data.surname}}                  
                </template>            
            </Column>

            <Column v-if="screenWidth >= 350"
            :header="translated('requestdate')"  :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">
                <template #body="slotProps">
                    {{ formatDate(slotProps.data.requestedDate) }}
                </template>
            </Column>

            <Column v-if="screenWidth >= 500"
            :header="translated('agreeddate')"  :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">
                <template #body="slotProps">
                    {{ formatDate(slotProps.data.agreedDate) }}
                </template>
            </Column>

            <Column :header="translated('status')"  :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">
                <template #body="slotProps">
                    {{ translated('status_' + slotProps.data.status) }}
                </template>
            </Column>
            <Column v-if="screenWidth >= 600"
            :header="translated('clientnotes')"  :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">
                <template #body="slotProps">
                    {{slotProps.data.clientNotes}}
                </template>
            </Column>

            <Column v-if="screenWidth >= 600"
            :header="translated('hvanalysisrequest')" :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">                
                <template #body="slotProps">
                    <p v-if="analysisCondition(slotProps.data.analysisRequestId)">
                        <router-link  :to="{ name: 'AnalysisReview', params: { id: slotProps.data.analysisRequestId}}"> 
                            {{analysisDisplay(slotProps.data.analysisRequestId)}}
                        </router-link>
                    </p>
                    <p v-else>
                        {{analysisDisplay(slotProps.data.analysisRequestId)}}
                    </p>
                </template>
            </Column> 

            <Column :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">
                <template #body="slotProps">
                    <i v-if="slotProps.data.paid" class="pi pi-credit-card payedIcon"></i>                  
                </template>            
            </Column>
            
            
            <Column headerStyle="width: 4em" bodyStyle="text-align: center">
                <template #body="{data}">
                    <router-link :to="{ name: 'HomeVisitReview', params: { id: data.id}}"> 
                        <Button icon="pi pi-info-circle" style="background-color:#0d89ec" class="p-button-raised p-button-secondary p-button-blue" />
                    </router-link>
                </template>
            </Column> 
        </DataTable>
	</div>

</template>

<script>
import createHttp from "@/services/http";
import router from "@/router/index";
import { computed } from "vue"
import store from "@/store";
import {FilterMatchMode} from 'primevue/api';

export default {
    components: { },
    data() {
        return {
        isLoading : true,
        allanalysis : [],
        filters1: null,
        translated: computed(() => store.getters.getTranslate),
        screenWidth: 0   
        }
    },
    created() {
      this.initFilters1();
    },
    async mounted() {
        
        const http = createHttp(true); 
        const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetAllHomeVisits");

        if(result.status==200){
            this.allanalysis = result.data
            
        }

        this.screenWidth = window.innerWidth;
        window.addEventListener('resize', this.updateScreenWidth);

        this.isLoading = false;

    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateScreenWidth);
    },
    methods: {
        formatDate(value) {
            if(value != null){
                let myDate = new Date(value);
    
                return myDate.toLocaleDateString('ro-RO');
            }
        },
        clearFilter1() {
            this.initFilters1();
        },
        initFilters1() {
            this.filters1 = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
            }
        },
        analysisDisplay(value){
            if(value === "00000000-0000-0000-0000-000000000000" || value == null || !value){
                return this.translated('no');//VUCI IZ TRANSLATEA!!!!!
            } else {
                return this.translated('yes');
            }
        },
        analysisCondition(value){
            if(value === "00000000-0000-0000-0000-000000000000" || value == null || !value){
                return false;
            } else {
                return true;
            }
        },
        updateScreenWidth() {
            this.screenWidth = window.innerWidth;
        }
    }
}
</script>

<style scoped>
.p-datatable-allhomevisits { width: 100%; }
</style>